module.exports = __webpack_public_path__ + "static/media/Keith Dean Headshot.d7af3fc9.jpeg";